import React from 'react';
import { documentConfig } from '../../constants/documentConfig';

const IconBack = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const TopBar = ({ docType, onBack }) => {
  const label = documentConfig[docType]?.label || docType || 'Results';
  return (
    <div className="top-bar">
      {onBack && (
        <button className="top-bar-back" onClick={onBack} aria-label="Back">
          <IconBack />
        </button>
      )}
      <span className="top-bar-title">{label}</span>
    </div>
  );
};

export default TopBar;
